import fs from 'node:fs'
import path from 'node:path'
import { stringifyProjectJson } from '@core-engine/utils/json-format.js'
import type { InstalledIntegrationManifest } from '@integration-engine/types.js'

function integrationsDir(cwd: string): string {
  return path.join(cwd, '.betterstart', 'integrations')
}

export function integrationManifestPath(cwd: string, integrationId: string): string {
  return path.join(integrationsDir(cwd), integrationId, 'manifest.json')
}

export function loadInstalledIntegrationManifest(
  cwd: string,
  integrationId: string
): InstalledIntegrationManifest | null {
  const filePath = integrationManifestPath(cwd, integrationId)
  if (!fs.existsSync(filePath)) return null
  return JSON.parse(fs.readFileSync(filePath, 'utf-8')) as InstalledIntegrationManifest
}

export function saveInstalledIntegrationManifest(
  cwd: string,
  manifest: InstalledIntegrationManifest
): void {
  const filePath = integrationManifestPath(cwd, manifest.id)
  fs.mkdirSync(path.dirname(filePath), { recursive: true })
  fs.writeFileSync(filePath, stringifyProjectJson(manifest), 'utf-8')
}

export function deleteInstalledIntegrationManifest(cwd: string, integrationId: string): void {
  fs.rmSync(path.dirname(integrationManifestPath(cwd, integrationId)), {
    recursive: true,
    force: true
  })
}
